import { graphql } from '@/gql/generated'

export const GetFeaturedSquigglesDocument = graphql(/* GraphQL */ `
  query GetFeaturedSquiggles($ownerAddresses: [String!]!, $projectId: String!) {
    tokens_metadata(
      where: { owner_address: { _in: $ownerAddresses }, project_id: { _eq: $projectId } }
      order_by: { invocation: asc }
    ) {
      id
      token_id
      invocation
      hash
      project {
        name
      }
    }
  }
`)
